// extracted by mini-css-extract-plugin
export default {"switchActionsGo":"styles_switchActionsGo__lfojq","garageSwitchGo":"styles_garageSwitchGo__ZyhVA","switchItemGo":"styles_switchItemGo__hNZhR"};